export default __webpack_public_path__ + "static/media/headerPopupFNAll.08993635.png";